import { createStore } from "vuex";
import { system } from "./modules/system/index.js";

// import createPersistedState from "vuex-persistedstate";
// import ls from "@/utils/local-storage";

const debug = process.env.NODE_ENV !== "production";
// 本地缓存 app，project
// const persistedPlugin = createPersistedState({
//   paths: ["app", "project", "works"],
//   storage: {
//     getItem: (key) => ls.get(key),
//     setItem: (key, value) => ls.set(key, value),
//     removeItem: (key) => ls.remove(key),
//   },
// });

export default createStore({
  modules: {
    system,
  },
  strict: debug,
  // plugins: debug ? [persistedPlugin] : [],
});
